module.exports = __webpack_public_path__ + "static/media/gray_animal_amphibians_6.73281e52.webp";